// extracted by mini-css-extract-plugin
export default {"container":"Container_container__-ka3v","small":"Container_small__UUJxH","fullWidth":"Container_fullWidth__0yunW"};